// User-friendly themes. Each sets variables + a data-theme attribute; index.css maps
// common utility colors so the whole app re-skins without touching every component.
export const THEMES = [
  { id: 'matrix', label: 'Guardian', vibe: 'Black & neon green · matches the commercial (default)', swatch: ['#000000', '#39ff14'], dark: true },
  { id: 'midnight', label: 'Midnight', vibe: 'Calm dark', swatch: ['#09090b', '#10b981'], dark: true },
  { id: 'enlightened', label: 'Enlightened', vibe: 'Warm light · spiritual & hopeful', swatch: ['#faf6ec', '#b8860b'], dark: false },
  { id: 'dawn', label: 'Dawn', vibe: 'Soft light · gentle & clear', swatch: ['#f7f7fb', '#4f46e5'], dark: false },
  { id: 'sanctuary', label: 'Sanctuary', vibe: 'Deep & peaceful', swatch: ['#0f1b17', '#34d399'], dark: true },
  { id: 'royal', label: 'Royal', vibe: 'Indigo & gold · dignified', swatch: ['#0e0b1e', '#d4af37'], dark: true },
  { id: 'ocean', label: 'Ocean', vibe: 'Cool blue · focused', swatch: ['#07131f', '#38bdf8'], dark: true },
];

const KEY = 'unmanip_theme_v3';

export function getTheme() {
  return localStorage.getItem(KEY) || 'matrix';
}

export function applyTheme(id) {
  const t = THEMES.find(x => x.id === id) || THEMES[0];
  document.documentElement.setAttribute('data-theme', t.id);
  document.documentElement.style.colorScheme = t.dark ? 'dark' : 'light';
  localStorage.setItem(KEY, t.id);
  window.dispatchEvent(new CustomEvent('unmanip:theme', { detail: t.id }));
}

export function initTheme() {
  applyTheme(getTheme());
}
